import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    timeout: {type: Number, default: 4000},
  }

  connect() {
    if (this.timeoutValue <= 0) return

    this.timeout = window.setTimeout(() => {
      this.dismiss()
    }, this.timeoutValue)
  }

  disconnect() {
    window.clearTimeout(this.timeout)
    window.clearTimeout(this.removeTimeout)
  }

  dismiss() {
    this.element.dataset.flashNoticeDismissing = "true"
    this.element.addEventListener("transitionend", this.remove, {once: true})
    this.removeTimeout = window.setTimeout(this.remove, 400)
  }

  remove = () => {
    this.element.remove()
  }
}
